export const contentSegments = ['website_core', 'design_system', 'website_news', 'website_guides', 'careers'];
